module.exports = __webpack_public_path__ + "static/media/content-copy.aa783cd0.svg";